import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Enrollment } from '../models/enrollment.model';
import { User } from './user.service';

const CURRENT_USER_SESSION_KEY = 'currentUser';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  token: string;
  callId: string;
  doctorId?: string;
  private enrollmentsSubject = new BehaviorSubject<Partial<Enrollment>[]>([]);
  diagnosisCompleteSubject = new BehaviorSubject(false);
  apiUrlSubject = new BehaviorSubject('');
  private currentUserSubject = new BehaviorSubject<User | null>(JSON.parse(sessionStorage.getItem(CURRENT_USER_SESSION_KEY) || 'null'));
  private userLoadedSubject = new BehaviorSubject<boolean>(sessionStorage.getItem(CURRENT_USER_SESSION_KEY) !== null);

  setToken(token: string): void {
    this.token = token;
  }

  getToken(): string {
    return this.token;
  }

  setCurrentUser(user: User | null): void {
    if (user) {
      sessionStorage.setItem(CURRENT_USER_SESSION_KEY, JSON.stringify(user));
    } else {
      sessionStorage.removeItem(CURRENT_USER_SESSION_KEY);
    }
    this.currentUserSubject.next(user);
    this.userLoadedSubject.next(true);
  }

  getCurrentUser(): User | null {
    return this.currentUserSubject.value;
  }

  get currentUser$(): Observable<User | null> {
    return this.currentUserSubject.asObservable();
  }

  get userLoaded$(): Observable<boolean> {
    return this.userLoadedSubject.asObservable();
  }

  markUserLoaded(): void {
    this.userLoadedSubject.next(true);
  }

  setCall(callId: string): void {
    this.callId = callId;
  }

  getCall(): string {
    return this.callId;
  }

  setDoctorId(doctorId: string): void {
    this.doctorId = doctorId;
  }

  getDoctorId(): string | undefined {
    return this.doctorId;
  }

  set enrollments(enrollments: Partial<Enrollment>[]) {
    this.enrollmentsSubject.next(enrollments);
  }

  get enrollments(): Partial<Enrollment>[] {
    return this.enrollmentsSubject.value;
  }

  get enrollments$(): Observable<Partial<Enrollment>[]> {
    return this.enrollmentsSubject.asObservable();
  }

  set diagnosisComplete(value: boolean) {
    this.diagnosisCompleteSubject.next(value);
  }

  get diagnosisComplete(): boolean {
    return this.diagnosisCompleteSubject.value;
  }

  get diagnosisComplete$(): Observable<boolean> {
    return this.diagnosisCompleteSubject.asObservable();
  }

  set apiUrl(apiUrl: string) {
    this.apiUrlSubject.next(apiUrl);
  }

  get apiUrl(): string {
    return this.apiUrlSubject.value;
  }

  get apiUrl$(): Observable<string> {
    return this.apiUrlSubject.asObservable();
  }
}
